import { gql } from '@apollo/client'
import { workforceLeaverByPeriodFragment } from '../fragments/dashboardWorkforce.fragments'
import { workforceNewEntryByPeriodFragment } from '../fragments/dashboardWorkforce.fragments'
import { workforceProbationPeriodEndingByPeriodFragment } from '../fragments/dashboardWorkforce.fragments'

/** Company Manager Dashboard — workforce movement counters. */
export const COMPANY_MANAGER_DASHBOARD_WORKFORCE_COUNTERS = gql`
  query CompanyManagerDashboardWorkforceCounters($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardWorkforceCounters(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      totalEmployees
      workforceMovementCounters {
        workforceMovementType
        currentMonth
        nextMonth
        previousMonth
      }
    }
  }
`

/** Company Manager Dashboard — new entries details. */
export const COMPANY_MANAGER_DASHBOARD_WORKFORCE_NEW_ENTRIES = gql`
  query CompanyManagerDashboardWorkforceNewEntries(
    $companyId: HashedId!
    $period: WorkforceMovementPeriodEnum
    $userDashboardRoles: [RoleName!]!
  ) {
    companyManagerDashboardWorkforceNewEntries(companyId: $companyId, period: $period, userDashboardRoles: $userDashboardRoles) {
      ...WorkforceNewEntryByPeriodFields
    }
  }
  ${workforceNewEntryByPeriodFragment}
`

/** Company Manager Dashboard — leavers details. */
export const COMPANY_MANAGER_DASHBOARD_WORKFORCE_LEAVERS = gql`
  query CompanyManagerDashboardWorkforceLeavers(
    $companyId: HashedId!
    $period: WorkforceMovementPeriodEnum
    $userDashboardRoles: [RoleName!]!
  ) {
    companyManagerDashboardWorkforceLeavers(companyId: $companyId, period: $period, userDashboardRoles: $userDashboardRoles) {
      ...WorkforceLeaverByPeriodFields
    }
  }
  ${workforceLeaverByPeriodFragment}
`

/** Company Manager Dashboard — probation period ending details. */
export const COMPANY_MANAGER_DASHBOARD_WORKFORCE_PROBATION_PERIOD_ENDING = gql`
  query CompanyManagerDashboardWorkforceProbationPeriodEnding(
    $companyId: HashedId!
    $period: WorkforceMovementPeriodEnum
    $userDashboardRoles: [RoleName!]!
  ) {
    companyManagerDashboardWorkforceProbationPeriodEnding(companyId: $companyId, period: $period, userDashboardRoles: $userDashboardRoles) {
      ...WorkforceProbationPeriodEndingByPeriodFields
    }
  }
  ${workforceProbationPeriodEndingByPeriodFragment}
`
